import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap flex-stack mb-10" }
const _hoisted_2 = { class: "fw-bold my-2 text-fprimary" }
const _hoisted_3 = { class: "ms-4 badge rounded-pill bg-fprimary" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_5 = {
  key: 0,
  class: "row row-cols-2 row-cols-lg-4 g-5 g-xl-9 mb-6 mb-xl-9"
}
const _hoisted_6 = {
  key: 0,
  class: "col"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: /*#__PURE__*/_normalizeClass(`position-absolute top-0 start-100 translate-middle badge rounded-pill bg-fsecondary`)
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_10 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "symbol symbol-60px mb-6" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = { class: "card-footer p-2 text-center" }
const _hoisted_17 = { class: "m-0" }
const _hoisted_18 = {
  key: 1,
  class: "col"
}
const _hoisted_19 = {
  class: "card h-100 border border-2 bg-light",
  style: {"cursor":"not-allowed"}
}
const _hoisted_20 = {
  class: /*#__PURE__*/_normalizeClass(`position-absolute top-0 start-100 translate-middle badge rounded-pill bg-secondary`)
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "...", -1)
const _hoisted_22 = { class: "card-body d-flex justify-content-center text-center flex-column p-8" }
const _hoisted_23 = { class: "text-gray-500 d-flex flex-column" }
const _hoisted_24 = { class: "symbol symbol-60px mb-6" }
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_27 = ["innerHTML"]
const _hoisted_28 = { class: "card-footer p-2 text-center" }
const _hoisted_29 = { class: "text-gray-400 m-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_DialogForms = _resolveComponent("DialogForms")!
  const _component_DrawerFormGeneral = _resolveComponent("DrawerFormGeneral")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h3", _hoisted_2, [
        _createTextVNode(_toDisplayString(_ctx.t("forms")) + " " + _toDisplayString(_ctx.t("available")) + " ", 1),
        _createElementVNode("span", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.listForms.length) + " ", 1),
          _hoisted_4
        ])
      ])
    ]),
    (_ctx.listForms.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listForms, (item, index) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `fl-s-${index}`
            }, [
              (item.enabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["card h-100 border border-2 cursor-pointer border-white shadow border-hover bg-opacity-50", `${item.status != null ? item.status?.params : 'bg-info'}`]),
                      onClick: ($event: any) => (_ctx.openDialogForm(item))
                    }, [
                      _createElementVNode("span", _hoisted_8, [
                        _createTextVNode(_toDisplayString(index + 1) + " ", 1),
                        _hoisted_9
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("div", _hoisted_12, [
                            _createElementVNode("img", {
                              src: `/media/svg/files/${'folder-document'}.svg`,
                              alt: ""
                            }, null, 8, _hoisted_13)
                          ]),
                          _createElementVNode("div", _hoisted_14, _toDisplayString(item.form_name), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "fs-7 fw-semibold mt-auto",
                          innerHTML: `${item.form_details}`
                        }, null, 8, _hoisted_15)
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.t('dateEnd')) + " " + _toDisplayString(_ctx.formatDate(item.end_date)), 1)
                      ])
                    ], 10, _hoisted_7)
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, [
                        _createTextVNode(_toDisplayString(index + 1) + " ", 1),
                        _hoisted_21
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", _hoisted_24, [
                            _createElementVNode("img", {
                              src: `/media/svg/files/${'folder-document'}.svg`,
                              alt: ""
                            }, null, 8, _hoisted_25)
                          ]),
                          _createElementVNode("div", _hoisted_26, _toDisplayString(item.form_name), 1)
                        ]),
                        _createElementVNode("div", {
                          class: "fs-7 fw-semibold text-gray-400 mt-auto",
                          innerHTML: `${item.form_details}`
                        }, null, 8, _hoisted_27)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("p", _hoisted_29, _toDisplayString(_ctx.t('dateEnd')) + " " + _toDisplayString(_ctx.formatDate(item.end_date)), 1)
                      ])
                    ])
                  ]))
            ], 64))
          }), 128))
        ]))
      : _withDirectives((_openBlock(), _createBlock(_component_el_empty, {
          key: 1,
          description: `${_ctx.t('notFoundResult')}`
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.getForms
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t('tryAgain')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["description"])), [
          [_directive_loading, _ctx.loader]
        ]),
    _createVNode(_component_DialogForms, {
      "item-form": _ctx.itemForm,
      idevent: _ctx.id,
      onModalClosed: _ctx.modalClosed
    }, null, 8, ["item-form", "idevent", "onModalClosed"]),
    _createVNode(_component_DrawerFormGeneral, {
      ref: "DrawerFormGeneralRef",
      "id-event": _ctx.id,
      "item-form": _ctx.itemForm,
      onModalClosed: _ctx.modalClosed
    }, null, 8, ["id-event", "item-form", "onModalClosed"])
  ], 64))
}